import { FormattedMessage, useIntl } from 'react-intl'

import { Checkbox } from '@gto/ui/checkbox'
import { Typography } from '@gto/ui/typography'

import { AgreementText } from './agreement-text'

export type AgreementStepProps = {
  agreed: boolean
  onAgreedChange: (agreed: boolean) => void
}

export const AgreementStep = ({ agreed, onAgreedChange }: AgreementStepProps) => {
  const { formatMessage } = useIntl()

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2 text-center">
        <Typography
          className="font-bold"
          color="text.primary"
          variant="h5"
        >
          <FormattedMessage id="onboarding.agreement.title" />
        </Typography>
        <Typography
          color="text.secondary"
          variant="body2"
        >
          <FormattedMessage id="onboarding.agreement.subtitle" />
        </Typography>
      </div>

      {/* Focusable + labelled so keyboard users can scroll the agreement and
          screen readers announce the region. */}
      <div
        aria-label={formatMessage({ id: 'onboarding.agreement.regionLabel' })}
        className="max-h-[320px] overflow-y-auto rounded-lg bg-paper-elevation3 p-6 ring-1 ring-inset ring-divider focus-visible:outline-2 focus-visible:outline-primary-main sm:max-h-[260px]"
        data-tst="agreement-scroll-region"
        role="region"
        tabIndex={0}
      >
        <Typography
          className="mb-4 font-bold"
          color="text.primary"
          variant="subtitle1"
        >
          <FormattedMessage id="terms.title" />
        </Typography>
        <AgreementText />
      </div>

      <Checkbox
        checked={agreed}
        data-tst="agreement-consent"
        label={<FormattedMessage id="onboarding.agreement.consent" />}
        onCheckedChange={onAgreedChange}
      />
    </div>
  )
}
